export function kkVideoTextMedia() {
    // Get all elements with class 'block-text-media'
    document.querySelectorAll('.block-text-media').forEach(function(block) {

        // For each block, get all elements with class 'media'
        block.querySelectorAll('.media').forEach(function(media) {

            // Add event listeners to elements with class 'play-button' or 'video-poster'
            media.querySelectorAll('.play-button, .video-poster').forEach(function(button) {
                button.addEventListener('click', function() {
                    // Hide the clicked element
                    button.style.display = 'none';

                    // Hide sibling elements with class 'video-poster' or 'play-button'
                    let videoPoster = button.parentElement.querySelector('.video-poster');
                    let playButton = button.parentElement.querySelector('.play-button');
                    if (videoPoster) videoPoster.style.display = 'none';
                    if (playButton) playButton.style.display = 'none';

                    // Play the video after a delay
                    setTimeout(() => {
                        let video = button.parentElement.querySelector('video');
                        if (video) {
                            video.play();
                        }
                    }, 450);

                    // Add autoplay parameter to iframe src
                    let iframe = button.parentElement.querySelector("iframe");
                    if (iframe) {
                        iframe.src += "&autoplay=1";
                    }
                });

                // Optionally, handle 'touchstart' event as well
                button.addEventListener('touchstart', function() {
                    button.click();
                });
            });

        });

    });

}
